<template>
  <a-modal :visible="visible" :title="$t('warning.warningOrder')" :width="700" :afterClose="clearInfo"
    :confirm-loading="isSubmitting" @cancel="closeModal" @ok="handleConfirm">
    <a-tabs v-model="activeTab" :animated="false" v-loading="isLoading" v-if="isEdit">
      <a-tab-pane key="detail" :tab="$t('warningOrder.orderDetail')">
        <a-form-model ref="orderFormRef" style="margin-top: 15px;" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }"
          :model="orderForm" :rules="orderFormRules">
          <a-form-model-item :label="$t('common.deviceCode')" required>
            <a-input @change="f" v-if="isFormEditable" v-model="orderForm.deviceCode" disabled />
            <span v-else>{{ orderForm.deviceCode }}</span>
          </a-form-model-item>
          <a-form-model-item :label="$t('device.warningType')" required>
            <a-select v-if="isFormEditable" v-model="orderForm.warningType" disabled>
              <a-select-option v-for="(v, k) in warningCodeNameMap" :key="k">
                {{ v[lang] }}
              </a-select-option>
            </a-select>
            <span v-else>{{ orderWarningType }}</span>
          </a-form-model-item>
          <a-form-model-item :label="$t('warning.orderLevel')" prop="level">
            <a-select v-if="isFormEditable" v-model="orderForm.level">
              <a-select-option v-for="(v, k) in levels" :key="k">
                {{ v[lang] }}
              </a-select-option>
            </a-select>
            <span v-else>{{ orderLevelName }}</span>
          </a-form-model-item>
          <a-form-model-item :label="$t('warning.reason')" prop="reason">
            <a-select v-if="isFormEditable" v-model="orderForm.reason" mode="tags" @change="f">
              <a-select-option v-for="h in reasons" :key="h.code" :value="h.reason">
                {{ h.reason }}
              </a-select-option>
            </a-select>
            <span v-else>{{ reasonInfo }}</span>
          </a-form-model-item>
          <a-form-model-item :label="$t('warning.orderDescription')" prop="description">
            <a-input @change="f" v-if="isFormEditable" v-model="orderForm.description" />
            <span v-else>{{ orderForm.description }}</span>
          </a-form-model-item>
          <a-form-model-item :label="$t('warning.handler')" prop="handler">
            <a-select v-if="isFormEditable" v-model="orderForm.handler">
              <a-select-option v-for="h in handlers" :key="h.username">
                {{ h.realName }} - {{ h.username }} - {{ h.roleName }}
              </a-select-option>
            </a-select>
            <span v-else>{{ handlerInfo.realName }} - {{ handlerInfo.username }} - {{ handlerInfo.roleName }}</span>
          </a-form-model-item>
          <a-form-model-item :label="$t('common.followers')" style="position: relative;">
            <a-spin size="small"
              style="position: absolute; top: 50%; transform: translateY(-50%); z-index: 10; left: 1.5%"
              v-show="isSearchingUser" />
            <a-select v-if="isFormEditable" show-search :value="orderForm.follower" :default-active-first-option="false"
              :show-arrow="false" :filter-option="false" :not-found-content="null"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode" @inputKeydown.enter="searchFollowers"
              @popupScroll="handleFollowerPopupScroll" @change="selectFollower">
              <a-select-option v-for="f in followers" :key="f.username">
                {{ f.realName }} - {{ f.username }} - {{ f.role }}
              </a-select-option>
            </a-select>
            <span v-else>{{ followerInfo.realName }} - {{ followerInfo.username }} - {{ followerInfo.role }}</span>
          </a-form-model-item>
          <a-form-model-item :label="$t('warningOrder.estimatedTime')">
            <a-date-picker v-if="isFormEditable" v-model="orderForm.estimatedTime" style="width: 100%;"
              placeholder="" />
            <span v-else>{{ estimatedTimeInfo }}</span>
          </a-form-model-item>
        </a-form-model>
      </a-tab-pane>
      <a-tab-pane key="deal" :tab="$t('warningOrder.handledDetails')">
        <a-form-model ref="dealFormRef" style="margin-top: 15px;" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }"
          :model="dealForm" :rules="dealFormRules">
          <a-form-model-item :label="$t('warningOrder.handleMethod')" prop="handleMethod">
            <a-select v-if="isFormEditable" v-model="dealForm.handleMethod" mode="tags" @change="f">
              <a-select-option v-for="h in handleMethods" :key="h.code" :value="h.handleMethod">
                {{ h.handleMethod }}
              </a-select-option>
            </a-select>
            <span v-else>{{ dealForm.handleMethod.join(";") }}</span>
          </a-form-model-item>
          <a-form-model-item :label="$t('warningOrder.solution')">
            <a-input @change="f" v-if="isFormEditable" v-model="dealForm.solution" />
            <span v-else>{{ dealForm.solution }}</span>
          </a-form-model-item>
          <a-form-model-item :label="$t('warningOrder.resolvable')">
            <a-switch v-if="isFormEditable" v-model="dealForm.unableSolve" :checked-children="$t('common.yes')"
              :un-checked-children="$t('common.no')" />
            <span v-else>{{ orderForm.unableSolve ? $t('common.yes') : $t('common.no') }}</span>
          </a-form-model-item>
          <a-form-model-item :label="$t('warningOrder.live')">
            <div class="upload">
              <button v-if="isFormEditable" aria-disabled="false" type="button" class="el-button el-button"
                :key="fileList.length">
                <span style="padding: 8px 15px;" class="" @click="showFileModal"><i
                    class="el-icon-upload"></i>&nbsp;&nbsp;{{ $t('buttons.uploadPic') }}</span>
              </button>
              <input ref="InputFileDOm" class="file" type="file" :accept="'.mp4,.jpg,.jpeg,.png,.webm'" :limit="6"
                @change="hadnleFileChange" multiple />
              <div class="upload-demo" data-v-1ab1ffd8="">
                <ul class="el-upload-list el-upload-list--text" :key="fileList.length">
                  <li tabindex="0" v-for="(file, index) in fileList" :key="srcList[index].path"
                    style="float: left;width: 100px; height: 100px; position: relative"
                    @mouseover="srcList[index].isMaskShow = true; $forceUpdate()"
                    @mouseleave="srcList[index].isMaskShow = false; $forceUpdate()">
                    <div v-show="srcList[index].isMaskShow" class="mask"
                      style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0, 0, 0, .3); z-index: 100; display: flex; justify-content: center; align-items: center; cursor: pointer;">
                      <a-icon type="eye" style="color: #ccc; font-size: 20px;" @click="previewImg(index)" />
                      <a-icon type="delete" v-if="isFormEditable" style="color: #ccc; font-size: 20px"
                        @click="rF(index)" />
                    </div>
                    <img :src="srcList[index].path"
                      style="width: 100%; height: 100%; object-fit: cover; cursor: pointer" />
                  </li>
                </ul>
              </div>
            </div>
          </a-form-model-item>
        </a-form-model>
      </a-tab-pane>
      <a-tab-pane key="comment" :tab="$t('warningOrder.comment')">
        <h4 class="flex">
          {{ orderCode }} - {{ orderWarningType }}
          <a-button v-show="!isCommentingInput" type="link" @click="showCommentInput">
            {{ $t("warningOrder.comment") }}
          </a-button>
        </h4>
        <a-empty v-if="comments.length === 0 && !isCommentingInput">
          <span slot="description">{{ $t('warningOrder.noComments') }}</span>
        </a-empty>
        <div v-else style="max-height: 520px; overflow: auto" v-loading="isCommentLoading">
          <div class="input_wrapper" v-show="isCommentingInput">
            <a-input @change="f" style="width: 90%; margin-right: 10px" v-model="comment" @keyup.enter="submitComment()" />
            <div class="comment_icons" style="display: inline-block;" v-show="!isSubmittingComment">
              <a-icon @click="submitComment()" style="margin-right: 10px; cursor: pointer" type="check" />
              <a-icon @click="clearComment" style="cursor: pointer;" type="close" />
            </div>
            <a-icon type="loading" v-show="isSubmittingComment" />
          </div>
          <ul>
            <li v-for="c in comments" :key="c.id" style="padding: 15px 0;">
              <span class="username">{{ c.realName }}: </span>
              <br />
              <div class="content">{{ c.content }}</div>
              <span class="time">{{ c.createdAt }}</span>
              <a-button type="link" @click="replyComment(c)">{{ $t("warningOrder.reply") }}</a-button><a-button
                type="link" style="color: red; padding-left: 0" @click="removeComment(c.id)" v-if="ableToDelete">{{
                  $t('buttons.delete') }}</a-button>
              <div class="input_wrapper" v-show="c.isRepling">
                <a-input @change="f" style="width: 90%; margin-right: 10px" v-model="comment" @keyup.enter="submitComment(c.id)" />
                <div class="comment_icons" style="display: inline-block;" v-show="!isSubmittingComment">
                  <a-icon @click="submitComment(c.id)" style="margin-right: 10px; cursor: pointer" type="check" />
                  <a-icon @click="clearComment" style="cursor: pointer;" type="close" />
                </div>
                <a-icon type="loading" v-show="isSubmittingComment" />
              </div>
              <ul style="padding-left: 30px" v-show="c.children && c.children.length">
                <li v-for="cc in c.children" :key="cc.id" style="padding: 15px 0;">
                  <span class="username">{{ cc.realName }}: </span>
                  <br />
                  <div class="content">{{ cc.content }}</div>
                  <span class="time">{{ cc.createdAt }}</span>
                  <a-button type="link" @click="replyComment(cc)">{{ $t("warningOrder.reply") }}</a-button><a-button
                    type="link" style="color: red; padding-left: 0" @click="removeComment(cc.id)" v-if="ableToDelete">{{
                      $t('buttons.delete') }}</a-button>
                  <div class="input_wrapper" v-show="cc.isRepling">
                    <a-input @change="f" style="width: 90%; margin-right: 10px" v-model="comment" />
                    <div class="comment_icons" style="display: inline-block;" v-show="!isSubmittingComment">
                      <a-icon @click="submitComment(c.id)" style="margin-right: 10px; cursor: pointer" type="check" />
                      <a-icon @click="clearComment" style="cursor: pointer;" type="close" />
                    </div>
                    <a-icon type="loading" v-show="isSubmittingComment" />
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </a-tab-pane>
    </a-tabs>
    <a-form-model v-else ref="orderFormRef" style="margin-top: 15px;" :label-col="{ span: 4 }"
      :wrapper-col="{ span: 19 }" :model="orderForm" :rules="orderFormRules">
      <a-form-model-item :label="$t('common.deviceCode')" required>
        <a-input @change="f" v-model="orderForm.deviceCode" disabled />
      </a-form-model-item>
      <a-form-model-item :label="$t('device.warningType')" required>
        <a-select v-model="orderForm.warningType" disabled>
          <a-select-option v-for="(v, k) in warningCodeNameMap" :key="k">
            {{ v[lang] }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('warning.orderLevel')" prop="level">
        <a-select v-model="orderForm.level">
          <a-select-option v-for="(v, k) in levels" :key="k">
            {{ v[lang] }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('warning.reason')" prop="reason">
        <a-select v-model="orderForm.reason" mode="tags" @change="f">
          <a-select-option v-for="h in reasons" :key="h.code" :value="h.reason">
            {{ h.reason }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('warning.orderDescription')" prop="description">
        <a-input @change="f" v-model="orderForm.description" />
      </a-form-model-item>
      <a-form-model-item :label="$t('warning.handler')" prop="handler">
        <a-select v-model="orderForm.handler">
          <a-select-option v-for="h in handlers" :key="h.username">
            {{ h.realName }} - {{ h.username }} - {{ h.roleName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('common.followers')" style="position: relative;">
        <a-spin size="small" style="position: absolute; top: 50%; transform: translateY(-50%); z-index: 10; left: 1.5%"
          v-show="isSearchingUser" />
        <a-select show-search :value="orderForm.follower" :default-active-first-option="false" :show-arrow="false"
          :filter-option="false" :not-found-content="null" :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          @inputKeydown.enter="searchFollowers" @popupScroll="handleFollowerPopupScroll" @change="selectFollower">
          <a-select-option v-for="f in followers" :key="f.username">
            {{ f.realName }} - {{ f.username }} - {{ f.role }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('warningOrder.estimatedTime')">
        <a-date-picker v-model="orderForm.estimatedTime" style="width: 100%;" placeholder="" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import {
  getReasonsList,
  getHandlersList,
  createOrder,
  queryOrders,
  getOrderByCode,
  updateOrder,
  getHandleMethodList,
  finishOrder,
  deleteOrderFile,
  getOrderCommentsList,
  createComment,
  deleteComment
} from "@/api/warningOrder"
import {
  searchUserList
} from "@/api/auth/user"
import { levels } from "@/views/Warning/orderSelectionOptions"

import moment from "moment"
import ReasonModal from "./ReasonModal.vue"
import HandleMethodModal from "./HandleMethodModal.vue"

export default {
  components: { ReasonModal, HandleMethodModal },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    closeModal: {
      type: Function,
      required: true
    },
    info: {
      type: Object,
      required: true
    },
    warningTypes: {
      required: true,
      type: Array
    },
    refresh: {
      type: Function,
      default: () => { }
    }
  },
  data() {
    return {
      activeTab: "detail",
      orderFormRules: {},
      orderForm: {
        deviceCode: "",
        level: undefined,
        warningType: undefined,
        description: "",
        handler: undefined,
        follower: undefined,
        estimatedTime: null
      },
      dealForm: {
        code: "",
        handleMethod: [],
        unableSolve: false
      },
      dealFormRules: {},
      fileList: [],
      isCommentingInput: false,
      isCommentLoading: false,
      comment: "",
      isSubmittingComment: false,
      comments: [],
      ableToDelete: false,
      isLoading: false,
      reasons: [],
      isEdit: false,
      warningCodeNameMap: {},
      levels,
      handlers: [],
      followers: [],
      isSearchingUser: false,
      isSubmitting: false,
      handleMethods: [],
      orderCode: "",
      orderWarningType: "",
      orderLevelName: "",
      isFormEditable: false,
      handlerInfo: {},
      followerInfo: {},
      estimatedTimeInfo: "",
      reasonInfo: "",
      isReasonModalVisible: false,
      isHandleMethodModalVisible: false
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler() {
        this.translate()
      }
    },
    visible(v) {
      if (v) {
        this.render()
      }
    }
  },
  created() {
    this.followerPage = 1
    this.searchFollowerFlag = true
    this.ableToDelete = this.getAuthorities("/warning/order").find(a => a.code === "warning:workOrder:comment:delete")
  },
  methods: {
    translate() {
      // 设置工单校验规则以及处理校验规则
      this.orderFormRules = {
        level: [
          {
            required: true,
            message: this.$t("warning.emptyLevel")
          }
        ],
        description: [
          {
            required: true,
            message: this.$t("warning.emptyDescription"),
            trigger: "blur"
          }
        ],
        handler: [
          {
            required: true,
            message: this.$t("warning.emptyHandler")
          }
        ]
      }
      this.dealFormRules = {
        handleMethod: [
          {
            required: true,
            message: this.$t("warningOrder.selectHandleMethod"),
            trigger: "blur"
          }
        ]
      }
    },
    async render() {
      this.isLoading = true
      this.isEdit = this.info.isEdit
      await this.initFormOptions()
      await this.setForm()
      this.isLoading = false
    },
    clearInfo() {
      this.clearOrderForm()
      this.dealForm = {
        code: "",
        handleMethod: [],
        unableSolve: false
      }
      this.$refs.dealFormRef?.clearValidate()
      this.activeTab = "detail"
    },
    clearOrderForm() {
      this.orderForm = {
        deviceCode: "",
        level: undefined,
        warningType: undefined,
        description: "",
        handler: undefined,
        follower: undefined,
        estimatedTime: null
      }
      this.followers = []
      this.followerPage = 1
      this.searchFollowerFlag = true
      this.searchWordsOfFollowers = ""
      this.$refs.orderFormRef?.clearValidate()
    },
    showFileModal() {
      this.$refs.InputFileDOm.click()
    },
    hadnleFileChange(e) {
      let i
      for (i = 0; i < e.target.files.length; i++) {
        if (!this.onBeforeUpload(e.target.files[i])) {
          break
        }
      }
      if (i == e.target.files.length) {
        console.log(this.fileList, e.target.files)
        this.fileList = this.fileList.concat(Array.from(e.target.files))
        console.log(this.fileList)
        this.srcList = this.fileList.map(f => {
          if (f.attachmentCode) {
            f.path = f.uri
            return f
          } else {
            return {
              path: '',
              isMaskShow: false
            }
          }
        })
        this.fileList.forEach((f, i) => {
          if (!f.attachmentCode) {
            const fr = new FileReader()
            fr.readAsDataURL(f)
            fr.onload = e => {
              this.srcList[i] = {
                path: "data:image/png;base64," + e.target.result.substring(e.target.result.indexOf(',') + 1),
                isMaskShow: false
              }
              this.$forceUpdate()
            }
          }
        })
      }
    },
    previewImg(i) {
      const imgList = this.srcList.map(s => s.path)
      this.$hevueImgPreview({
        multiple: true,
        nowImgIndex: i,
        imgList
      })
    },
    rF(i) {
      this.$Mconfirm(this.$t('messages.ctrp'), this.$t('messages.hint'), {
        confirmButtonText: this.$t('common.okText'),
        cancelButtonText: this.$t('common.cancelText'),
        type: "warning"
      })
        .then(async () => {
          if (this.fileList[i].id) {
            await deleteOrderFile(this.orderCode, this.fileList[i].attachmentCode)
            this.setForm()
            this.$EM({
              type: "success",
              message: this.$t('messages.rs')
            })
          } else {
            const arr = [...this.fileList]
            arr.splice(i, 1)
            this.srcList.splice(i, 1)
            this.fileList = arr
            this.$forceUpdate()
            this.$EM({
              type: "success",
              message: this.$t('messages.rs')
            })
          }
          return true
        })
        .catch((e) => {
          console.log(e)
          this.$EM({
            type: "info",
            message: this.$t('messages.cr')
          });
        })
    },
    onBeforeUpload(file) {
      let acceptTypes;

      acceptTypes = [
        "image/jpg",
        "image/jpeg",
        "image/png"
      ];

      if (file.size > 1024 * 1024 * 500) {
        // 文件大于 30M 时取消上传
        ElNotification({
          type: "error",
          message: this.$t('messages.lessThan500MB')
        });
        return false;
      }
      if (!acceptTypes.includes(file.type)) {
        // 继续上传
        ElNotification({
          type: "error",
          message: this.$t('messages.rightFile')
        });
        return false; // 停止上传
      }
      return true;
    },
    showCommentInput() {
      this.setRepling()
      this.isCommentingInput = true
    },
    setRepling(flag = false) {
      this.isCommentingInput = flag
      let c, cc
      for (let i = 0; i < this.comments.length; i++) {
        c = this.comments[i]
        c.isRepling = flag
        if (c.children) {
          for (let j = 0; j < c.children.length; j++) {
            cc = c.children[j]
            cc.isRepling = flag
          }
        }
      }
    },
    async submitComment(pid) {
      if (!this.comment) {
        return this.$message.warning(this.$t("warningOrder.enterComment"))
      }
      const o = {
        workOrderCode: this.orderCode,
        content: this.comment
      }
      if (pid) {
        o.pid = pid
      }
      this.isSubmittingComment = true
      try {
        const { message } = await createComment(o)
        this.$message.success(message)
        this.setRepling()
        this.comment = ""
        this.comments = await this.requestComments(this.orderCode)
        this.setCommentItemsTime()
      } catch (e) {
        console.log(e)
      } finally {
        this.isSubmittingComment = false
      }
    },
    clearComment() {
      this.setRepling()
      this.comments = [...this.comments]
      this.comment = ""
    },
    replyComment(c) {
      this.setRepling()
      c.isRepling = true
      this.comments = [...this.comments]
    },
    removeComment(id) {
      const okButtonProps = {
        props: {
          loading: false
        }
      }
      this.$confirm({
        title: this.$t("warningOrder.confirmToDelete"),
        content: this.$t("warningOrder.confirm"),
        okButtonProps,
        onOk: async () => {
          try {
            const { message } = await deleteComment(id)
            this.$message.success(message)
            this.isCommentLoading = true
            this.comments = await this.requestComments(this.orderCode)
            this.setCommentItemsTime()
          } catch (e) {
            console.log(e)
          }
        }
      })
    },
    async initFormOptions() {
      this.setWarningTypeNameMap()
      this.handlers = await this.getHandlers()
      this.handleMethods = await this.getHandleMethods()
      this.reasons = await this.getReasons()
    },
    async setForm() {
      this.orderForm.deviceCode = this.info.deviceCode
      this.orderForm.warningType = this.info.warningType
      if (this.isEdit) {
        let orderCode = this.info.code
        if (!orderCode) {
          orderCode = await this.requestOrders(this.info.deviceCode, this.info.warningType)
        }
        this.orderCode = orderCode
        this.orderWarningType = this.warningCodeNameMap[this.info.warningType][this.lang]
        const orderDetail = await this.requestOrderDetail(orderCode)
        this.orderForm.level = orderDetail.level
        this.orderForm.handler = orderDetail.handler
        this.orderForm.follower = orderDetail.follower === "undefined" ? "" : orderDetail.follower
        this.orderForm.description = orderDetail.description
        const uneditableStatus = ["CHECKING", "FAILED", "SUCCEED"]
        this.isFormEditable = !uneditableStatus.includes(orderDetail.status)
        if (orderDetail.estimatedTime) {
          this.orderForm.estimatedTime = moment(orderDetail.estimatedTime)
        }
        if (orderDetail.follower) {
          const user = await this.requestUserInfoByUsername(orderDetail.follower)
          this.followers = [user]
          this.followerInfo = user
        }
        if (!this.isFormEditable) {
          const h = this.handlers.find(h => h.username === orderDetail.handler)
          if (h) {
            this.handlerInfo = h
          }
          this.orderLevelName = this.levels[orderDetail.level][this.lang]
          this.reasonInfo = orderDetail.reason
          this.estimatedTimeInfo = orderDetail.estimatedTime ? moment(+orderDetail.estimatedTime).format("YYYY-MM-DD") : ""
        }
        if (orderDetail.reason) {
          this.orderForm.reason = orderDetail.reason.split(";")
        }
        if (orderDetail.handleMethod) {
          this.dealForm.handleMethod = orderDetail.handleMethod.split(";")
        }
        this.dealForm.solution = orderDetail.solution
        this.dealForm.unableSolve = orderDetail.unableSolve
        this.fileList = []
        this.srcList = []
        if (orderDetail.attachments) {
          orderDetail.attachments.forEach(a => {
            this.fileList.push(a)
            this.srcList.push({
              isMaskShow: false,
              path: a.uri
            })
          })
        }
        const comments = await this.requestComments(orderCode)
        this.comments = comments
        this.setCommentItemsTime()
      }
    },
    async getHandlers() {
      try {
        const { data } = await getHandlersList(this.info.deviceCode)
        return data
      } catch (e) {
        console.log(e)
        return []
      }
    },
    async getHandleMethods() {
      try {
        const { data } = await getHandleMethodList(this.info.warningType)
        return data
      } catch (e) {
        console.log(e)
        return []
      }
    },
    async getReasons() {
      try {
        const { data } = await getReasonsList(this.info.warningType)
        return data
      } catch (e) {
        console.log(e)
        return []
      }
    },
    setWarningTypeNameMap() {
      let t
      const map = {}
      for (let i = 0; i < this.warningTypes.length; i++) {
        t = this.warningTypes[i]
        map[t.routeName] = {
          zh: t["zh-CN"],
          en: t["en-US"]
        }
      }
      this.warningCodeNameMap = map
    },
    async searchFollowers(e) {
      this.isSearchingUser = true
      this.searchWordsOfFollowers = e.target.value.trim()
      this.followerPage = 1
      this.searchFollowerFlag = true
      const { data } = await this.requestUsers(this.searchWordsOfFollowers)
      this.followers = data
      this.isSearchingUser = false
    },
    async requestUsers(value) {
      try {
        const { data } = await searchUserList(this.followerPage, 10, {
          query: [
            {
              field: "realName",
              value
            }
          ],
          filter: [],
          sort: []
        })
        return {
          data: data.records,
          total: data.total
        }
      } catch (e) {
        console.log(e)
        return {
          data: [],
          total: 0
        }
      }
    },
    async handleFollowerPopupScroll(e) {
      if (!this.searchFollowerFlag) {
        return
      }
      const { scrollHeight, scrollTop, clientHeight } = e.target
      if (scrollHeight - scrollTop === clientHeight) {
        this.followerPage++
        const { data, total } = await this.requestUsers(this.searchWordsOfFollowers)
        this.followers = this.followers.concat(data)
        if (this.followers.length >= total) {
          this.searchFollowerFlag = false
        }
      }
    },
    selectFollower(v) {
      this.orderForm.follower = v
      this.$forceUpdate()
    },
    handleConfirm() {
      switch (this.activeTab) {
        case "detail":
          this.submitOrderForm()
          break
        case "deal":
          this.submitDealForm()
          break
        case "comment":
          this.closeModal()
          break
        default:
          break
      }
    },
    submitOrderForm() {
      this.$refs.orderFormRef.validate(async valid => {
        if (valid) {
          this.isSubmitting = true
          const form = { ...this.orderForm }
          if (form.estimatedTime) {
            form.estimatedTime = +form.estimatedTime._d
          } else {
            form.estimatedTime = ""
          }
          if (form.reason) {
            form.reason = form.reason.join(";")
          }
          try {
            if (this.isEdit) {
              form.code = this.orderCode
              const { message } = await updateOrder(form)
              this.$message.success(message)
              this.closeModal()
              this.refresh()
            } else {
              const { message } = await createOrder(form)
              this.$message.success(message)
              this.closeModal()
              this.refresh()
            }
          } catch (e) {
            console.log(e)
          } finally {
            this.isSubmitting = false
          }
        }
      })
    },
    async requestOrders(code, warningType) {
      try {
        const { data } = await queryOrders(1, 10, {
          query: [],
          filter: [
            {
              field: "deviceCode",
              value: code
            },
            {
              field: "warningType",
              value: warningType
            },
            {
              field: "mode",
              value: "and"
            }
          ]
        })
        if (data.total) {
          return data.records[0].code
        }
        return ""
      } catch (e) {
        console.log(e)
        return ""
      }
    },
    async requestOrderDetail(c) {
      try {
        const { data } = await getOrderByCode(c)
        return data
      } catch (e) {
        return {}
      }
    },
    async requestUserInfoByUsername(username) {
      try {
        const { data } = await searchUserList(1, 10, {
          query: [],
          filter: [
            {
              field: "username",
              value: username
            }
          ],
          sort: []
        })
        if (data.total) {
          return data.records[0]
        }
        return {}
      } catch (e) {
        console.log(e)
        return {}
      }
    },
    submitDealForm() {
      this.$refs.dealFormRef.validate(async valid => {
        if (valid) {
          this.isSubmitting = true
          const form = { ...this.dealForm }
          form.handleMethod = form.handleMethod.join(";")
          form.code = this.orderCode
          try {
            const { message } = await finishOrder(form, this.fileList.filter(f => !f.id))
            this.$message.success(message)
            this.closeModal()
            this.refresh()
          } catch (e) {
            console.log(e)
          } finally {
            this.isSubmitting = false
          }
        }
      })
    },
    async requestComments(c) {
      try {
        const { data } = await getOrderCommentsList(c)
        return data
      } catch (e) {
        console.log(e)
        return []
      }
    },
    setCommentItemsTime() {
      let c, cc
      for (let i = 0; i < this.comments.length; i++) {
        c = this.comments[i]
        if (c.createdAt) {
          c.createdAt = moment(c.createdAt).format("YYYY-MM-DD HH:mm:ss")
          console.log(c.createdAt)
        }
        if (c.children) {
          for (let j = 0; j < c.children.length; j++) {
            cc = c.children[j]
            if (cc.createdAt) {
              cc.createdAt = moment(cc.createdAt).format("YYYY-MM-DD HH:mm:ss")
            }
          }
        }
      }
    },
    removeReason(i) {
      this.orderForm.reason.splice(i, 1)
      this.$forceUpdate()
    },
    removeHandleMethod(i) {
      this.dealForm.handleMethod.splice(i, 1)
      this.$refs.dealFormRef.validate()
    },
    f() {
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="less" scoped>
input.file {
  display: none;
}

.flex {
  display: flex;
  justify-content: space-between;
}

ul {
  padding: 0;
}

/deep/ .ant-select-disabled, .ant-input-disabled {
  color: rgba(0, 0, 0, .65);
}
</style>